import g from '#core/global';
import load from '#core/load';


const wireframe_attr = 'data-wireframe';
const locked_attr = 'data-wireframe-locked';
const storage_key = 'wireframe-mode';
const url_param = 'wireframe';
const shortcut_key = 'KeyW';


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('wireframe')) return false;

		activate_from_storage();
		load.content(() => {
			bind_shortcut();
		});
	},

	/**
	 * Toggle wireframe mode
	 */
	toggle() {
		toggle_mode();
	},

};

export default module;
module.init();


/**
 * Activate wireframe mode from URL param or session storage
 */
function activate_from_storage() {
	if (is_locked()) {
		document.documentElement.setAttribute(wireframe_attr, '');
		return;
	}

	const params = new URLSearchParams(window.location.search);
	if (params.has(url_param) || sessionStorage.getItem(storage_key)) {
		document.documentElement.setAttribute(wireframe_attr, '');
	}
}


/**
 * Bind keyboard shortcut to toggle wireframe mode
 */
function bind_shortcut() {
	document.addEventListener(g.keydown_e, (e) => {
		if (e.altKey && !e.ctrlKey && !e.metaKey && e.code === shortcut_key) {
			e.preventDefault();
			module.toggle();
		}
	});
}


/**
 * Toggle wireframe mode attribute and persist state
 */
function toggle_mode() {
	const $root = document.documentElement;

	if (is_locked()) {
		$root.setAttribute(wireframe_attr, '');
		sessionStorage.removeItem(storage_key);
		return;
	}

	const is_wireframe_active = $root.hasAttribute(wireframe_attr);

	if (is_wireframe_active) {
		$root.removeAttribute(wireframe_attr);
		sessionStorage.removeItem(storage_key);
	} else {
		$root.setAttribute(wireframe_attr, '');
		sessionStorage.setItem(storage_key, '1');
	}
}

function is_locked() {
	return document.documentElement.hasAttribute(locked_attr);
}
